@custom-media --mobile (max-width: 768px);

.searchContainer {
  margin-bottom: 1em;
}

.searchButton {
  margin-left: auto;

  &::after {
    font-size: 1.5em;
  }
}

.searchForm {
  display: none;

  &.visible {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  @media (--mobile) {
    flex-direction: column;
  }
}

.surveyCodeSearch {
  flex-basis: 30%;
  margin: 0.25em;
}

.degreeProgramSearch,
.stateSearch {
  flex-basis: 30%;
  margin: 0.25em;
}

.dateSearch {
  flex-basis: 30%;
  margin: 0.25em;
  display: flex;
  flex-direction: row;

  & > div {
    flex: 1;
    margin-right: 0.25em;
    margin-left: 0.25em;
  }

  & > div:first-child {
    flex: 25%;
    margin-left: 0;
  }

  & > div:last-child {
    flex: 25%;
    margin-right: 0;
  }
}
